import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import logo from "assets/img/LOGO-OCSB.gif";

import RegsugarService from "../services/regsugar.service";
// import useFetch from './useFetch';

const BlogDetails = () => {
  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  useEffect(() => {
    RegsugarService.checkRegsugarcane(id)
      .then((response) => {
        setData(response.data);
        setIsPending(false);
      })
      .catch((err) => setError(err));
  }, [id]);

  return (
    <Container>
      <div className="blog-details">
        {isPending && <div>Loading...</div>}
        {error && <div>{error}</div>}
        {data === null ? (
          <h2>ไม่มีเลขชาวไร่อ้อย</h2>
        ) : (
          <article>
            <div style={{ textAlign: "center" }}>
              <img src={logo} width="200" height="200" alt="Logo"></img>
            </div>

            <h2>เลขบัตรประจำตัวชาวไร่อ้อย : {data.farmer_card_id}</h2>
            <hr></hr>
            <h4>ชื่อ : {data.name}</h4>
            <h4
              style={
                data.status_text == "ชาวไร่"
                  ? { color: "green" }
                  : { color: "red" }
              }
            >
              สถานะ : {data.status_text}
            </h4>
          </article>
        )}
      </div>
    </Container>
  );
};

export default BlogDetails;
